import { z } from 'zod';
const HEX_COLOR = /^#[0-9a-fA-F]{6}$/;
// Logo URL discipline (review-hardened):
//   - real URL parse (z.string().url()) catches malformed inputs the
//     bare regex would miss (e.g. spaces, missing host)
//   - max 2048 chars so an operator can't paste an arbitrarily large
//     blob and have us echo it to every unauthenticated chrome render
//   - refine prefix to lowercase https:// — case-insensitive scheme
//     check rejects HTTPS://, http://, data:, javascript:, etc. We
//     avoid `new URL()` because @ng-unifi/domain runs under lib:["ES2022"]
//     with no DOM/Node lib in scope; the URL constructor isn't a typed
//     global there. The .url() check above already validates structure.
//
// We deliberately do NOT yet allowlist domains. Until in-portal upload
// + storage lands, operators host the logo file themselves. The release
// notes will call out that an externally hosted logo may expose client
// IP + UA to the host; an allowlist or proxy is a follow-up.
const HttpsUrl = z
    .string()
    .url()
    .max(2048)
    .refine((v) => v.toLowerCase().startsWith('https://'), 'must use https://');
export const TerminologyOverridesSchema = z.object({
    resident_label: z.string().min(1).max(40).nullable(),
    employee_label: z.string().min(1).max(40).nullable(),
    building_label: z.string().min(1).max(40).nullable(),
});
export const BrandingSchema = z.object({
    logo_url: HttpsUrl.nullable(),
    brand_color: z.string().regex(HEX_COLOR).nullable(),
    terminology: TerminologyOverridesSchema,
});
export const PutBrandingBody = z.object({
    logo_url: HttpsUrl.nullable().optional(),
    brand_color: z.string().regex(HEX_COLOR).nullable().optional(),
    terminology: TerminologyOverridesSchema.partial().optional(),
});
export const DEFAULT_BRANDING = {
    logo_url: null,
    brand_color: null,
    terminology: {
        resident_label: null,
        employee_label: null,
        building_label: null,
    },
};
//# sourceMappingURL=branding.js.map